"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Target = /** @class */ (function () {
    function Target(element, descriptor, id) {
        this.boundingRect = {};
        this.boundings = {};
        this.element = element;
        this.descriptor = descriptor;
        this.id = this.descriptor.id + "-" + id;
        this.element._apolloId = this.id;
        if (typeof this.descriptor.callback !== 'function')
            this.descriptor.callback = function () { };
        this.calculateBoundings();
    }
    Target.prototype.frame = function (delta) {
        this.calculateBoundings();
    };
    Target.prototype.render = function (delta) {
    };
    Target.prototype.postRender = function (delta) {
    };
    Target.prototype.calculateBoundings = function () {
        this.boundingRect = this.element.getBoundingClientRect();
        this.boundings = {
            top: this.boundingRect.top - this.descriptor.offset.y,
            bottom: this.boundingRect.bottom + this.descriptor.offset.y,
            left: this.boundingRect.left - this.descriptor.offset.x,
            right: this.boundingRect.right + this.descriptor.offset.x,
            width: this.boundingRect.width + (this.descriptor.offset.x * 2),
            height: this.boundingRect.height + (this.descriptor.offset.y * 2),
        };
    };
    return Target;
}());
exports.default = Target;
